const de = {
  forbidden_page: {
    message: 'Sie sind nicht berechtigt, diese Seite zu sehen.',
  },

  page_404: {
    message: '(404) Diese Seite existiert nicht.',
    click: 'Klicken',
    here: 'hier',
    to_return: 'um zur Startseite zurückzukehren.',
  },

  login_page: {
    digital: 'Digital',
    inspection_jacket: 'Inspection Jacket',
    logging_in: 'Anmeldung...',
  },

  dashboard_page: {
    welcome: 'Willkommen',
    intro: 'End-to-End-Lösung für digitale Inspektion.',
    scan_project_code: 'Projektcode scannen',
    new_version_available: 'Neue Version verfügbar!',
    websocket_status: 'WebSocket-Status',
    dij_version: 'Digital Inspection Jacket {version}',
  },

  header: {
    app_name: 'Digital Inspection Jacket',
  },

  task_page: {
    create_new_task: 'Neue Aufgabe erstellen',
    back_to_product_list:
      'Nachdem Sie fertig sind, gehen Sie bitte zurück zur Produktvorlagenliste, damit andere an dieser Vorlage arbeiten können',
    back_to_work_order_list:
      'Nachdem Sie fertig sind, gehen Sie bitte zurück zur Arbeitsauftragliste, damit andere an diesem Auftrag arbeiten können',
    drop_file_reference_image:
      'Datei hier ablegen oder klicken, um ein Referenzbild hochzuladen',
    reference_image: 'Referenzbild',
    signed_off_by: 'Abgenommen von {name}',
    task_not_available_offline: 'Aufgabe ist offline nicht verfügbar',
    need_help_chat: 'Brauchen Sie Hilfe? Klicken Sie hier, um zu chatten!',
    loading_user_roles: 'Benutzerrollen werden geladen...',
    loading_job_details: 'Auftragsdetails werden geladen...',
    checking_job_status: 'Auftragsstatus wird geprüft...',
    loading_job_tasks: 'Aufgaben werden geladen...',
    deleting_task: 'Aufgabe wird gelöscht...',
    duplicating_folder: 'Ordner wird dupliziert...',
    select_folder_to_move: 'Ordner zum Verschieben auswählen.',
    delete_folder_confirmation_message:
      'Das Löschen eines Ordners entfernt alle enthaltenen Aufgaben.',
    delete_confirmation: 'Möchten Sie wirklich löschen?',
  },

  create_new_user_page: {
    create_new_user: 'Neuen Benutzer erstellen',
    create_user: 'Benutzer erstellen',
    firstName: 'Vorname',
    lastName: 'Nachname',
    gid: 'GID',
    email: 'E-Mail',
    password: 'Passwort',
    role: 'Rolle',
    all_fields_required: 'Bitte füllen Sie alle erforderlichen Felder aus.',
    user_failed: 'Benutzererstellung fehlgeschlagen.',
    user_success: 'Benutzer wurde erfolgreich erstellt.',
    password_validation:
      'Passwortanforderungen: mindestens 8 Zeichen, ein Kleinbuchstabe, ein Großbuchstabe, eine Zahl, keine Teile Ihres Benutzernamens.',
  },

  change_password_page: {
    change_password: 'Passwort ändern',
    change_user_password: 'Benutzerpasswort ändern',
    password_change_success: 'Passwort wurde erfolgreich geändert',
    secret_question_success: 'Sicherheitsfrage wurde erfolgreich gesetzt',
    password_change_fail: 'Passwort konnte nicht geändert werden.',
    secret_question_fail: 'Sicherheitsfrage konnte nicht gesetzt werden',
    email: 'E-Mail',
    oldPassword: 'Altes Passwort',
    password: 'Neues Passwort',
    confirmNewPassword: 'Neues Passwort bestätigen',
    password_should_match:
      'Neues Passwort und Bestätigung müssen übereinstimmen.',
    password_validation:
      'Passwortanforderungen: mindestens 8 Zeichen, ein Kleinbuchstabe, ein Großbuchstabe, eine Zahl, keine Teile Ihrer E-Mail.',
    passwordLowerCase:
      'Passwort muss mindestens einen Kleinbuchstaben enthalten.',
    passwordUpperCase:
      'Passwort muss mindestens einen Großbuchstaben enthalten.',
    passwordNumber: 'Passwort muss mindestens eine Ziffer enthalten.',
    passwordMinLength: 'Passwort muss mindestens 8 Zeichen lang sein.',
    passwordNoUsernameParts:
      'Passwort darf keinen Teil des Benutzernamens enthalten.',
  },

  profile_page: {
    myProfile: 'Mein Profil',
    account: 'Konto',
    preferences: 'Einstellungen',
    profileUpdated: 'Profil erfolgreich aktualisiert',
    updatePreferences: 'Einstellungen aktualisieren',
    updateAccount: 'Konto aktualisieren',
    my_name: 'Mein Name',
    username: 'Benutzername',
    email: 'E-Mail',
    location: 'Standort',
    phone_number: 'Telefonnummer',
  },

  task_view: {
    cancel: 'Abbrechen',
    back: 'Zurück',
    save: 'Speichern',
    delete: 'Löschen',
    deleteConfirmation:
      'Möchten Sie die Aufgabe <b>{taskTitle}</b> wirklich <b>löschen</b>?',
    deleteTask: 'Aufgabe löschen',
    manageMte: 'Instrumentenprotokoll',
    repairAssessment: 'Reparaturbewertung',
    importAccuScan: 'AccuScan importieren',
    importLaserscan: 'Laserscan importieren',
    signOff: 'Abnehmen',
    orderItem: 'Artikel bestellen',
  },

  text_size: 'Textgröße',
  selection: 'Auswahl',
  alignedlength: 'Ausgerichtete Länge',
  linearlength: 'Lineare Länge',
  positive_tolerance: '+ Toleranz',
  negative_tolerance: '- Toleranz',

  product_template_list: 'Produktvorlagenliste',
  work_order_list: 'Arbeitsauftragliste',
  update: 'Aktualisieren',
  order: 'Reihenfolge',
  select_folder: 'Ordner auswählen',
  move: 'Verschieben',
  add_task: 'Aufgabe hinzufügen',
  add_folder: 'Ordner hinzufügen',
  add_field: 'Feld hinzufügen',
  message_order_drag: 'Jetzt können Sie Ihre Aufgaben anordnen, ziehen Sie sie einfach',
  move_folder: 'In Ordner verschieben',
  move_selected: 'Ausgewählte verschieben',
  select: 'Auswählen',
  delete_selected: 'Ausgewählte löschen',

  admin: 'Administrator',
  editor: 'Editor',
  publisher: 'Publisher',
  inspector: 'Inspektor',
  report: 'Bericht',
  dashboard: 'Dashboard',
  profile: 'Profil',
  language: 'Sprache',
  view_profile: 'Profil anzeigen',
  manage_fleet_data: 'Flottendaten verwalten',
  report_issue: 'Problem melden',
  request_content: 'Inhalt anfordern',
  contact_us: 'Kontakt',
  forum: 'Viva Engage Forum',
  training: 'Schulung',
  log_out: 'Abmelden',

  choose_language: 'Wählen Sie Ihre bevorzugte Sprache.',

  create_new_product: 'Neues Produkt erstellen',
  title: 'Titel',
  product_line: 'Produktlinie',
  original_OEM: 'Ursprünglicher OEM',
  frame_type: 'Rahmentyp',
  model: 'Modell',
  part_number: 'Teilenummer',
  document_number: 'Dokumentnummer',
  revision: 'Revision',
  cancel: 'Abbrechen',
  submit: 'Senden',
  delete: 'Löschen',
  save: 'Speichern',
  done: 'Fertig',
  new_product_success: 'Neues Produkt erfolgreich erstellt.',
  new_product_fail_message:
    'Fehler beim Erstellen des neuen Auftrags! Bitte erneut versuchen.',

  // Tool names inside diagram
  'Selection Tool': 'Auswahlwerkzeug',
  'Pan Viewport': 'Ansicht verschieben',
  Diameter: 'Durchmesser',
  'Run-Out': 'Rundlauf',
  'Linear Length': 'Lineare Länge',
  'Visual Inspection': 'Visuelle Inspektion',
  Text: 'Text',
  'Generic Measurement': 'Allgemeine Messung',
  Arrow: 'Pfeil',
  Line: 'Linie',
  'Replace Image': 'Bild ersetzen',

  // Bubble names
  generic: 'Generischer Marker',
  generic_name: 'Generischer Name',
  runout: 'Rundlauf',
  length: 'Länge',
  diameter: 'Durchmesser',
  arrow: 'Pfeil',
  line: 'Linie',
  text: 'Text',
  visualInspection: 'Visuelle Inspektion',

  // Bubble properties
  label_numbers_only: 'Beschriftung (nur Zahlen)',
  expected_value: 'Erwarteter Wert',
  decimals: 'Dezimalstellen',
  units: 'Einheiten',
  inch: 'Zoll',
  mm: 'mm',
  tolerance_type: 'Toleranzart',
  tolerance: 'Toleranz',
  multiple_positions: 'Mehrere Positionen',
  edit_table: 'Tabelle bearbeiten',
  orientation: 'Ausrichtung',
  measurement_name: 'Messname',
  visual_name: 'Visual-Name',
  marker_description: 'Beschreibung',
  generic_marker_tolerance: 'Toleranz',
  direction: 'Richtung',
  degrees: 'Grad',
  clock: 'Uhr',
  rotate_text: 'Text drehen',
  rubbed: 'Gerieben',
  damaged: 'Beschädigt',
  pitted: 'Grübchen',
  eroded: 'Erodierte',
  high: 'Hoch',
  low: 'Niedrig',
  medium: 'Mittel',
  acceptable: 'Akzeptabel',
  all: 'Alle',
  position: 'Position',
  tir: 'TIR',
  ok: 'OK',
  in: 'Zoll',
  iso_name: 'ISO',
  iso_grade: 'ISO-Grad',
  RAT: 'RAT',
  none: 'Keine',

  // Save or discard dialog
  save_or_discard_dialog_content: 'Möchten Sie Ihre Änderungen speichern?',
  discard: 'Verwerfen',
  stay: 'Bleiben',
  back: 'Zurück',
  dismiss: 'Schließen',

  import_drawing: 'Zeichnung importieren',
  work_order_list: 'Arbeitsauftragsliste',

  edit_name: 'Name bearbeiten',
  reopen: 'Erneut öffnen',

  //Instruction actions
  create_new_item: 'Neuen Eintrag erstellen',
  choose_one_item: 'Einen Eintrag auswählen',
  order_item: 'Eintrag bestellen',
  action: 'Aktion',
  yes_no: 'Ja/Nein',
  options: 'Optionen',
  add_iso: 'ISO hinzufügen',
  add_calculation: 'Berechnung hinzufügen',
  recover: 'Wiederherstellen',
  loading: 'Laden...',
  clear_filters: 'Filter löschen',
  job_downloaded_locally: 'Auftrag lokal heruntergeladen',
  job_has_incomplete_data: 'Auftrag hat unvollständige Daten',
  job_includes_repair_assessment: 'Auftrag enthält Reparaturbewertungen',
  text: 'Text',
  sap_reference: 'SAP-Referenz',
  filter: 'Filter',
  current_owner: 'Aktueller Eigentümer',
  current_owner_date: 'Aktueller Eigentümer / Datum',

  template_list: {
    retrieving_listings: 'Einträge werden anhand Ihrer Suche abgerufen...',
    fetched_pages_found:
      '{batchCount} Seiten bisher abgerufen. {size} Einträge gefunden...',
    found_listings: '{length} Einträge gefunden, die den Suchkriterien entsprechen.',
    failed_to_fetch_listings: 'Einträge konnten nicht abgerufen werden',
  },

  table: 'Tabelle',
  import_csv: 'CSV importieren',

  action_requested: 'Aktion angefordert',
  picture_taken_is_mandatory: 'Bildaufnahme ist erforderlich.',
  picture_uploaded_successfully: '{image} erfolgreich hochgeladen',
  picture_required: 'Bild erforderlich.',
  your_question: 'Ihre Frage',
  question: 'Frage',
  options: 'Option',
  add_an_option: 'Option hinzufügen',
  multiple_choice: 'Mehrfachauswahl',
  text_or_number: 'Text oder Zahl',

  number_of_rows: 'Anzahl der Zeilen',
  number_of_columns: 'Anzahl der Spalten',
  edit_rows: 'Zeilen bearbeiten',
  edit_columns: 'Spalten bearbeiten',
  only_numbers_and_alphabets:
    'In einer Zelle sind nur Zahlen und Buchstaben bis zu 16 Zeichen erlaubt',
  table_headings_not_empty: 'Tabellenüberschriften dürfen nicht leer sein',
  upload_diagram: 'Diagramm hochladen',

  yes: 'Ja',
  no: 'Nein',

  product_template_list: 'Produktvorlagenliste',
  product_line: 'Produktlinie',
  work_order_list: 'Arbeitsauftragsliste',
  favorite_list: 'Favoritenliste',
  search: 'Suche',
  add_product: 'Produkt hinzufügen',
  title: 'Titel',
  original_OEM: 'Ursprünglicher OEM',
  frame_type: 'Rahmentyp',
  model: 'Modell',
  part_number: 'Teilenummer',
  location: 'Standort',
  document_number: 'Dokumentnummer',
  revision: 'Revision',
  created_by: 'Erstellt von',
  date: 'Datum',
  edit: 'Bearbeiten',
  delete: 'Löschen',
  duplicate: 'Duplizieren',
  copyfrom: 'Kopieren von',
  nothing_here: 'Nichts hier',

  project_number: 'Projekt Nummer',
  customer: 'Kunde',
  work_order_number: 'Arbeitsauftragsnummer',
  serial_number: 'Seriennummer',
  sales_force_number: 'Sales-Force-Nummer',
  add_order: 'Auftrag hinzufügen',
  edit_order: 'Auftrag bearbeiten',
  original_oem_number: 'Original OEM-Nummer',
  freefinding: 'Freier Befund',

  part_level: 'Teilebene',

  new_product_success_message: 'Neues Produkt erfolgreich erstellt!',
  new_product_fail_message:
    'Fehler beim Erstellen des neuen Auftrags! Bitte erneut versuchen.',

  task_count: 'Aufgabenanzahl',
  selection_from_list: 'Falls gewünscht, eine Auswahl aus der Liste treffen',
  select_tasks: 'Aufgaben auswählen',
  select_products: 'Produkte auswählen (optional)',

  select_all: 'Alle auswählen',
  deselect_all: 'Auswahl aufheben',
  select_site: 'Standort auswählen',
  selected_products: 'Ausgewählte Produkte',
  review: 'Prüfen',
  sites: 'Sekundäre Standorte',
  products: 'Produkte',
  tasks: 'Aufgaben',
  next: 'Weiter',

  sign_off: 'Abnehmen',
  sign_off_questions_completed: '{completed}/{total} abgeschlossen.',
  sign_off_diagram_completed: 'Diagramm {percent}% abgeschlossen.',
  sign_off_comments_label: 'Bitte geben Sie hier Ihre Kommentare ein...',
  number_of_measurement_points: 'Anzahl der Messpunkte',
  stage: 'Stufe',
  number_of_stages: 'Anzahl der Stufen',
  add_job_with_table_message:
    'Entschuldigung, Sie können keine neuen Aufträge hinzufügen, da Sie einen Auftrag mit einer Aufgabentabelle ausgewählt haben.',
  configure_table_order: 'Tabelle konfigurieren',
  version: 'Version',
  task_completed_message:
    'Aufgabe bereits abgenommen! Bitte zum Bearbeiten erneut öffnen!',

  create_task: {
    create_new_task: 'Neue Aufgabe erstellen',
    diagram: 'Diagramm',
    instruction: 'Anweisung',
    worksheet: 'Arbeitsblatt',
    task_name: 'Aufgabenname',
    cancel: 'Abbrechen',
    done: 'Fertig',
    select_software_tool: 'Software-Tool auswählen',
  },

  create_folder: {
    create_new_folder: 'Neuen Ordner erstellen',
    folder_name: 'Ordnername',
    select_software_tool: 'Software-Tool auswählen',
    configure_new_part: 'Neues Teil konfigurieren',
    draw_no_b_plan: 'Zeichnungsnr. (B-Plan)',
    draw_no: 'Zeichnungsnr.',
    draw_no_turbinenlaufer: 'Zeichnungsnr. (Turbinenläufer)',
    draw_no_nutenplan: 'Zeichnungsnr. (Nutenplan)',
    draw_no_welle_vorne: 'Zeichnungsnr. (Wellenende vorne)',
    draw_no_welle_hinten: 'Zeichnungsnr. (Wellenende hinten)',
    draw_no_einstromteil: 'Zeichnungsnr. (Einstromteil)',
    draw_no_abstromteil: 'Zeichnungsnr. (Abstromteil)',
    rotor_id: 'Rotor-ID',
    parts_list: 'Teileliste',
    hallmark: 'Prüfzeichen',
    delete_title: 'LÖSCHEN',
    delete_field_confirmation: 'Feld {label} löschen?',
    name_prompt: 'Name',
    field_already_exists: 'Feld existiert bereits.',
    failed_create_task: 'Fehler beim Erstellen der neuen Aufgabe',
  },

  emfProductList: {
    workOrderList: 'Arbeitsauftragsliste',
    search: 'Suche',
    addOrder: 'Auftrag hinzufügen',
    next: 'Weiter',
    previous: 'Zurück',

    productLine: 'Produktlinie',
    title: 'Titel',
    originalOEM: 'Ursprünglicher OEM',
    frameType: 'Rahmentyp',
    model: 'Modell',
    partNumber: 'Teilenummer',
    customer: 'Kunde',
    projectNumber: 'Projekt Nr.',
    serialNumber: 'Seriennr.',
    workOrder: 'Arbeitsauftrag',
    salesForce: 'Sales-Force-Opportunity-Nr.',
    createdBy: 'Erstellt von',
  },

  loginSession: {
    admin: 'Administrator',
    editor: 'Editor',
    publisher: 'Publisher',
    inspector: 'Inspektor',
    report: 'Bericht',
    dashboard: 'Dashboard',
    language: 'Sprache',
    profile: 'Profil',
    viewProfile: 'Profil anzeigen',
    manageFleetData: 'Flottendaten verwalten',
    reportIssue: 'Problem melden',
    requestContent: 'Inhalt anfordern',
    contactUs: 'Kontakt',
    training: 'Schulung',
    logOut: 'Abmelden',
  },

  404: 'Nicht gefunden',

  table_template: {
    create_table: 'Tabelle erstellen',
    new_column: 'Neue Spalte hinzufügen',
    new_row: 'Neue Zeile hinzufügen',
    delete_column: 'Ausgewählte Spalte löschen',
    delete_row: 'Ausgewählte Zeile löschen',
  },

  calculation: {
    sum: 'Summe',
    sub: 'Subtrahieren',
    mult: 'Multiplizieren',
  },

  duplicate_work_order_number:
    'Die angegebene Arbeitsauftragsnummer wird bereits verwendet',
  view_qr_code: 'QR-Code anzeigen',
  download_qr_code: 'QR-Code herunterladen',
  download_traveler: 'Traveler herunterladen',
  include_repair_assessment: 'Reparaturbewertung einschließen',
  repair_assessment: 'Reparaturbewertung',
  import: 'Importieren',
  import_editor_template: 'Bestehende Vorlagen',
  import_add_excel_file: 'Aus Excel-Datei hinzufügen',
  download_excel_file: 'Vorlagendatei herunterladen',
  export_task: 'Aufgabe exportieren',
  saved: 'Gespeichert',
  not_saved: 'Nicht gespeichert',
  level: 'Ebene',
  assembly: 'Baugruppe',
  item_number: 'Positionsnummer',
  part_name: 'Teilename',
  part_number: 'Teilenummer',
  quantity: 'Menge',
  serialNumber: 'Seriennummer',
  actions: 'Aktionen',
  no_records: 'Keine Einträge',
  repair_assessment_empty:
    'Die Reparaturbewertung ist leer. Beginnen Sie mit dem Import von Daten oder fügen Sie sie manuell hinzu',
  repair_assessment_empty_readonly: 'Die Reparaturbewertung ist leer.',
  close: 'Schließen',
  close_notification: 'Benachrichtigung schließen',
  import_add: 'Importieren',
  change_log: 'Änderungsprotokoll',

  add_row: 'Zeile hinzufügen',
  remove_row: 'Zeile entfernen',

  repair_assessment_excel_import_failed:
    'Reparaturbewertung konnte nicht aus der Excel-Datei importiert werden',

  reuse: 'Wiederverwenden',
  repair: 'Reparieren',
  replace: 'Ersetzen',
  missing: 'Fehlend',
  client_reject: 'Kundenablehnung',
  received: 'Eingegangen',
  quality_control_override: 'QS',
  reviewed: 'Ing.-Prüfung',
  comments: 'Kommentare',

  findings: 'Befunde',
  recommendations: 'Empfehlungen',

  visual: 'Visuell',
  dim: 'Dim',
  ndt: 'NDT',

  summary: 'Zusammenfassung',
  repair_scope: 'Reparaturumfang',
  estimated_labor: 'Gesch. Stunden',

  not_repair_engineer: 'Nur Ingenieure dürfen prüfen',

  pre_assembly_audit: 'Vormontage-Audit',
  donwload_rat: 'Komponenten exportieren',
  repair_assessment_search_empty: 'Keine Elemente verfügbar.',

  delete_all: 'Alle löschen',
  delete_all_message:
    'Dies löscht alle Informationen im Zusammenhang mit der Reparaturbewertung.',
  delete_major_message:
    'Dies löscht Informationen zu Hauptkomponenten im Zusammenhang mit der Reparaturbewertung.',
  delete_minor_message:
    'Dies löscht Informationen zu Nebenkomponenten im Zusammenhang mit der Reparaturbewertung.',

  repair_assessment_row_locked: 'Diese Zeile ist von {user} gesperrt',

  feature_disabled: 'Diese Funktion ist an Ihrem Standort deaktiviert',

  locations: 'Standorte',

  recycle_bin: 'Papierkorb',
  recycle_bin_empty: 'Der Papierkorb ist leer',

  task_name: 'Name',
  task_type: 'Typ',
  deleted_by: 'Gelöscht von',
  deleted_at: 'Gelöscht am',

  executing_site: 'Ausführender Standort',

  na: 'k. A.',

  owner: 'Eigentümer',

  mtetype_create_title: 'MTE-Typ erstellen',
  mtetype_update_title: 'MTE-Typ aktualisieren',

  create: 'Erstellen',

  name: 'Name',
  needs_master: 'Benötigt Master',
  is_master: 'Ist Master',

  mte_type_delete_question:
    'Möchten Sie diesen MTE-Typ wirklich löschen?',
  mte_type_delete_success: 'MTE-Typ erfolgreich gelöscht',
  mte_type_delete_fail: 'MTE-Typ konnte nicht gelöscht werden',

  mte_management: 'Instrumentenprotokoll',
  add_using_camera: 'Mit Kamera hinzufügen',
  close_camera: 'Kamera schließen',
  add_manual_entry: 'Manuellen Eintrag hinzufügen',

  id: 'ID',
  type: 'Typ',
  due_date: 'Fälligkeitsdatum',
  master: 'Master',
  created_at: 'Erstellt am',

  masters: 'Master',
  non_masters: 'Andere',

  mandatory_error_message: '{field} ist erforderlich',
  mandatory_date_must_not_be_in_past_error_message:
    '{field} ist erforderlich und darf nicht in der Vergangenheit liegen',
  unique_error_message: '{field} muss eindeutig sein',

  task_locked_by_user: 'Aufgabe ist von {user} bis {date} gesperrt',

  clear: 'Zurücksetzen',
  surrogate: 'Stellvertreter',
  stop_surrogating: 'Stellvertretung beenden',

  create_new_site_page: {
    siteName: 'Standortname',
    city: 'Stadt',
    state: 'Bundesland',
    country: 'Land',
    create_new_site: 'Neuen Standort erstellen',
    all_fields_required: 'Bitte füllen Sie alle erforderlichen Felder aus.',
    site_failed: 'Standorterstellung fehlgeschlagen.',
    site_success: 'Standort erfolgreich erstellt.',
  },

  edit_site_page: {
    edit_site: 'Standort bearbeiten',
    siteName: 'Standortname',
    city: 'Stadt',
    state: 'Bundesland',
    country: 'Land',
    rat: 'Reparaturbewertungsvorlage',
    mte_m: 'Instrumentenprotokoll',
    delete: 'Löschen',
    update: 'Aktualisieren',
    successMessage: 'Standort erfolgreich aktualisiert.',
    failedMessage: 'Standort konnte nicht aktualisiert werden.',
    delete_confirm: 'Möchten Sie diesen Standort wirklich löschen?',
    deletesite: 'Standort erfolgreich gelöscht.',
    deletefail: 'Standort konnte nicht gelöscht werden.',
  },
  site_list: {
    siteName: 'Standortname',
    city: 'Stadt',
    state: 'Bundesland',
    country: 'Land',
    DateModified: 'Änderungsdatum',
  },
  announcement_banner: {
    title: 'Ankündigungsbanner',
    description: 'Richten Sie das Ankündigungsbanner ein.',
    status: 'Status',
    message: 'Nachricht',
    start_date: 'Startdatum',
    end_date: 'Enddatum',
    clear_action: 'Zurücksetzen',
    preview_action: 'Vorschau',
    save_action: 'Speichern',
    enabled_status: 'Aktiviert',
    disabled_status: 'Deaktiviert',
    clear_question:
      'Dies deaktiviert das Benachrichtigungsbanner für alle Benutzer. Fortfahren?',
    end_date_error: 'Enddatum muss in der Zukunft liegen',
  },
  edit_user_profile: {
    title: 'Benutzerprofil',
    user_owned_template_count: 'Dieser Benutzer ist Besitzer von {count} Vorlagen',
    user_owned_job_count: 'Dieser Benutzer ist Besitzer von {count} Aufträgen',
    reassign_jobs: 'Aufträge neu zuweisen',
    reassign_templates: 'Vorlagen neu zuweisen',
    reassign_jobs_cancel: 'Neuzuweisung abbrechen',
    pending_approval_message:
      'Dieser Benutzer wartet auf Freigabe. Prüfen Sie die Benutzerdaten und genehmigen Sie das Profil, damit der Benutzer DIJ nutzen kann',
    rejected_message:
      'Dieser Benutzer wurde abgelehnt und kann nicht auf DIJ zugreifen. Der Benutzer kann bei Bedarf trotzdem genehmigt werden.',
    success_message: 'Benutzer erfolgreich aktualisiert',
    full_name: 'Vollständiger Name',
    email: 'E-Mail',
    primary_location: 'Primärer Standort',
    secondary_locations: 'Sekundäre Standorte',
    phone_number: 'Telefonnummer',
    role: 'Rolle',
    power_admin_role: 'Power-Admin',
    placeholder_role: 'Rolle',
    ownership: 'Eigentümerschaft',
    additional_permissions: 'Zusätzliche Berechtigungen',
    enginner_review_permission: 'Ingenieurprüfung',
    delete_button: 'Löschen',
    update_button: 'Aktualisieren',
    approve_button: 'Genehmigen',
    reject_button: 'Ablehnen',
    cancel_button: 'Abbrechen',
    approve_question:
      'Sie genehmigen jetzt den Benutzer {name} mit der Rolle "{role}" und den Standorten "{locations}". Fortfahren?',
    reject_question:
      'Sie lehnen jetzt {name} ab. Der Benutzer kann DIJ nicht nutzen. Fortfahren?',
    approve_success_message: 'Der Benutzer wurde erfolgreich genehmigt',
    reject_success_message: 'Der Benutzer wurde erfolgreich abgelehnt',
    update_success_message: 'Benutzerinformationen wurden erfolgreich aktualisiert',
    job_reassignment_success_message:
      'Die Vorlagen dieses Benutzers wurden erfolgreich neu zugewiesen',
  },
  new_user_welcome_page: {
    welcome_configurator_message:
      'Willkommen bei DIJ. Bitte wählen Sie die für Ihre Arbeit relevanten Standorte aus',
    pending_approval_part1_message:
      'Ihr Zugriffsantrag wartet auf Genehmigung.',
    pending_approval_part2_message: 'Bitte später wiederkommen für Zugriff.',
    submit: 'Senden',
  },
  user_list: {
    name: 'Vollständiger Name',
    email: 'E-Mail',
    location: 'Standort',
    role: 'Rolle',
    last_login: 'Letzte Anmeldung',
  },
  users: {
    approved: 'Genehmigt',
    approved_description:
      'Liste der genehmigten Benutzer. Diese Benutzer haben vollen Zugriff auf DIJ.',
    pending_approval: 'Ausstehende Genehmigung',
    pending_approval_description:
      'Liste der Benutzer, die genehmigt werden müssen. Diese Benutzer können DIJ erst nach Genehmigung ihres Profils nutzen.',
    todays_logins: 'Heutige Anmeldungen',
    todays_logins_description:
      'Liste der Benutzer, die sich heute angemeldet haben. Wird täglich um Mitternacht zurückgesetzt.',
    rejected: 'Abgelehnt',
    rejected_description:
      'Liste der Benutzer, die im Genehmigungsprozess abgelehnt wurden. Diese Benutzer wissen nicht, dass sie abgelehnt wurden.',
  },
  user_picker: {
    label: 'Benutzer auswählen',
    placeholder: 'Tippen und verfügbare Benutzer auswählen',
    no_match_found: 'Keine Übereinstimmung gefunden',
    email: 'E-Mail',
    role: 'Rolle',
  },

  sign_off_instruction_not_completed:
    'Einige Anweisungen in der Aufgabe wurden nicht vollständig abgeschlossen. Möchten Sie die Aufgabe trotzdem abnehmen? Dadurch wird die Aufgabe für zukünftige Änderungen gesperrt.',
  sign_off_diagram_not_completed:
    'Einige Prüfpunkte in der Aufgabe wurden nicht abgeschlossen. Möchten Sie die Aufgabe trotzdem abnehmen? Dadurch wird die Aufgabe für zukünftige Änderungen gesperrt.',

  chat_box: {
    generated_content_warning:
      'Inhalte werden automatisch von KI erzeugt und können Ungenauigkeiten enthalten',
    type_message_placeholder: 'Nachricht eingeben...',
    send: 'Senden',
    regenerate: 'Neu generieren',
    please_wait: 'Bitte warten...',
    clear_local_history: 'Lokalen Verlauf löschen',
    click_to_copy: 'Zum Kopieren klicken',
  },
  report_template: {
    project_title: 'Projekttitel',
    enter_project_number: 'Projektnummer eingeben',
    customer: 'Kunde',
    enter_customer_information: 'Kundeninformationen eingeben',
    customer_tag: 'Kunden-Tag',
    enter_customer_tag: 'Kunden-Tag eingeben',
    customer_po_no: 'Kunden-Bestellnr.',
    unit_serial: 'Geräteseriennummer',
    enter_serial_info: 'Seriennummer eingeben',
    unit_model: 'Gerätemodell',
    project_number: 'Projektnummer',
    sales_force_opportunity_number: 'Sales-Force-Opportunity-Nummer',
    enter_sales_force_opportunity_number:
      'Sales-Force-Opportunity-Nummer eingeben',
    process: 'Prozess',
    enter_process: 'Prozess eingeben',
    original_order_no: 'Ursprüngliche Bestellnr.',
    enter_original_order_no: 'Ursprüngliche Bestellnr. eingeben',
    previous_orders: 'Vorherige Bestellungen',
    enter_previous_orders: 'Vorherige Bestellungen eingeben',
    contact_person_name: 'Name der Kontaktperson',
    enter_contact_person_name: 'Name der Kontaktperson eingeben',
    contact_person_department: 'Abteilung der Kontaktperson',
    executive_summary: 'Zusammenfassung',
    generate_executive_summary: 'Zusammenfassung generieren',
    repair_select: 'Reparaturauswahl',
    sample_text: 'Beispieltext:',
    sample_text_content:
      'Siemens erbrachte technische Dienstleistungen im Auftrag von Duke Energy Carolinas LLC, um eine EMM32A3N-Rotorbaugruppe zu inspizieren und Reparaturempfehlungen zu geben. Die Rotorbaugruppe war zur Eingangskontrolle in das Siemens-Reparaturwerk in Charlotte, North Carolina, gesendet worden.',
    revision_description: 'Revisionsbeschreibung',
    enter_revision_description: 'Revisionsbeschreibung eingeben',
    csm: 'CSM',
    enter_csm: 'CSM eingeben',
    repair_engineer: 'Reparaturingenieur',
    enter_repair_engineer: 'Reparaturingenieur eingeben',
    major_components: 'Hauptkomponenten',
    minor_components: 'Nebenkomponenten',
    work_performed_fact_finding:
      'Durchgeführte Arbeiten für die Faktenermittlung',
    work_performed_repair: 'Durchgeführte Arbeiten für die Reparatur',
    repairs_not_completed_recommendations_upgrades:
      'Reparaturen nicht abgeschlossen, Empfehlungen & Upgrades',
    appendix: 'Anhang',
  },

  report_header: {
    internal_report: 'Interner Bericht',
    customer_report: 'Kundenbericht',
    exclude_items: 'Elemente ausschließen',
    documents: 'Dokumente',
    revisions: 'Revisionen',
    description: 'Beschreibung: {description}',
    download: 'Herunterladen',
    header: 'Kopfzeile',
    deviation_report: 'Abweichungsbericht',
    repair_assessment: 'Reparaturbewertung',
    work_performed: 'Durchgeführte Arbeiten',
    deleting_report_revision: 'Berichtsrevision wird gelöscht',
    delete_revision_confirmation:
      'Möchten Sie die Revision <b>löschen</b>: {fileName}, Beschreibung: {description}? Diese Aktion kann nicht rückgängig gemacht werden.',
    delete_revision: 'Revision löschen',
  },

  report_tasks: {
    table: 'TABELLE',
    form_inspection: 'FORMPRÜFUNG',
    document_number: 'Dokumentnummer:',
    revision: 'Revision:',
    no_records: 'Keine Einträge',
    item: 'EINTRAG',
    answer: 'ANTWORT',
    attachments_uc: 'ANHANG(ÄNGE)',
    inspector: 'INSPEKTOR',
    date: 'DATUM',
    inspection_diagram: 'PRÜFDIAGRAMM',
    length_measurements: 'LÄNGENMESSUNGEN',
    diameter_measurements: 'DURCHMESSERMESSUNGEN',
    visual_inspection: 'VISUELLE INSPEKTION',
    generic_measurements: 'ALLGEMEINE MESSUNGEN',
    label_uc: 'Beschriftung',
    part_name_uc: 'Teilename',
    description_uc: 'Beschreibung',
    question_label: 'Frage:',
    name_label: 'Name:',
    description_label: 'Beschreibung:',
    expected_value_uc: 'Erwarteter Wert',
    tolerance1: 'Toleranz1',
    tolerance2: 'Toleranz2',
    unit: 'Einheit',
    inspector_title: 'Inspektor',
    date_title: 'Datum',
    condition: 'Zustand',
    severity: 'Schweregrad',
    measurement_name_uc: 'Messname',
    runout_measurements: 'RUNDLAUFMESSUNGEN',
    tir: 'TIR',
    tolerance: 'Toleranz',
    task_prefix: 'Aufgabe:',
    show_oot_colors: 'Farben außerhalb der Toleranz anzeigen',
    free_finding: 'FREIER BEFUND',
    attachments_plain: 'ANHÄNGE',
    pictures: 'Bilder',
    excluded: 'ausgeschlossen',
  },

  deviation_report: {
    unit_serial: 'Geräteseriennummer:',
    review_only: 'Nur zur Prüfung',
    action_required: 'Aktion erforderlich',
    assembly_bom: 'Stückliste Baugruppe',
    assembly_ref: 'Baugruppen-Referenz',
    item_number: 'Pos.-Nr.',
    original_pn: 'Originale Teilenr.',
    actions: 'Aktionen',
  },

  external_data: {
    title: 'EXTERNE DATEN',
    upload_failed: 'Datei-Upload fehlgeschlagen',
    item_uc: 'EINTRAG',
    file_name: 'Dateiname',
    print_to_report: 'In Bericht drucken',
    file_type_error: 'Dieser Dateityp kann nicht in den Bericht gedruckt werden',
    delete: 'Löschen',
  },

  findings: {
    title: 'BEFUNDE',
    by_inspector: 'Vom Inspektor',
    by_reporter: 'Vom Berichterstatter',
    placeholder: 'Bitte geben Sie hier Ihre Befunde ein...',
  },
};

export default de;
